export const permissions = [
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('./index.vue'),
    meta: {
      rule: 'PERMISSIONS',
      authRequired: true,
      title: 'general.permissions',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.permissions',
          disabled: true,
          href: '#/permissions'
        }
      ]
    }
  }
]